import Image from '@atlaskit/image';
import lozengeAnatomyLight from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-anatomy-light.png";
import lozengeAnatomyDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-anatomy-dark.png";
import lozengeStatusDo from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-do-1-light.png";
import lozengeStatusDont from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dont-1-light.png";
import lozengeStatusDoDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-do-1-dark.png";
import lozengeStatusDontDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dont-1-dark.png";
import lozengeSemanticAccentDo from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-do-2-light.png";
import lozengeSemanticAccentDont from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dont-2-light.png";
import lozengeSemanticAccentDoDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-do-2-dark.png";
import lozengeSemanticAccentDontDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dont-2-dark.png";
import lozengeTriggerDo from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-do-4-light.png";
import lozengeTriggerDont from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dont-4-light.png";
import lozengeTriggerDoDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-do-4-dark.png";
import lozengeTriggerDontDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dont-4-dark.png";
import lozengeCaseDo from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-do-5-light.png";
import lozengeCaseDont from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dont-5-light.png";
import lozengeCaseDoDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-do-5-dark.png";
import lozengeCaseDontDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dont-5-dark.png";
import lozengeBadgeDoLight from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-badge-do-light.png";
import lozengeBadgeDontLight from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-badge-dont-light.png";
import lozengeBadgeDoDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-badge-do-dark.png";
import lozengeBadgeDontDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-badge-dont-dark.png";
import * as React from 'react';
export default {
  Image,
  lozengeAnatomyLight,
  lozengeAnatomyDark,
  lozengeStatusDo,
  lozengeStatusDont,
  lozengeStatusDoDark,
  lozengeStatusDontDark,
  lozengeSemanticAccentDo,
  lozengeSemanticAccentDont,
  lozengeSemanticAccentDoDark,
  lozengeSemanticAccentDontDark,
  lozengeTriggerDo,
  lozengeTriggerDont,
  lozengeTriggerDoDark,
  lozengeTriggerDontDark,
  lozengeCaseDo,
  lozengeCaseDont,
  lozengeCaseDoDark,
  lozengeCaseDontDark,
  lozengeBadgeDoLight,
  lozengeBadgeDontLight,
  lozengeBadgeDoDark,
  lozengeBadgeDontDark,
  React
};